<template>
  <div class="section-slot-page">
    <div class="back-bg"></div>
    <div class="bg-blur">
      <div class="conic-gradient"></div>
    </div>

    <transition name="route" mode="out-in">
      <PreLoader v-if="isLoadingCardGames" />
    </transition>

    <div class="container">
      <div class="section__header text-center">
        <h1 class="section__title">GAMES</h1>
      </div>

      <div class="d-flex flex-column w-100 position-sticky sticky-filters">
        <div class="game-filters">
          <button v-for="filter in gameFilters" :key="filter.type" class="filter-button"
            :class="{ active: selectedFilter === filter.type }" @click="setFilter(filter.type)">
            {{ filter.label }}
          </button>
        </div>

        <div :class="this.selectedFilter === 'coming-soon' ? 'disabled-filt' : ''"
          class="w-100 d-flex justify-content-center align-items-center">
          <div v-if="uniqueCertCodes.length > 0" class="certification-filters d-flex justify-content-start mt-2">
            <button class="cert-filter-btn" :class="{ active: selectedCert === 'all' }" @click="selectedCert = 'all'">
              All Certs
            </button>
            <button v-for="code in uniqueCertCodes" :key="code" class="cert-filter-btn"
              :class="{ active: selectedCert === code }" @click="selectedCert = code">
              <img :src="getFlagUrl(code)" class="mini-flag" alt="" />
              <span class="text-uppercase">{{ code }}</span>
            </button>
          </div>
        </div>

        <div class="search-bar-container">
          <div class="search-bar" ref="searchBarContainer">
            <input title="Search games..." id="search-games-input" type="search" v-model="searchQuery"
              placeholder="Search games..." :class="{ expanded: isSearchExpanded }" />
            <button v-if="!isSearchExpanded" class="search-button fade-in-fwd" @click="toggleSearch"
              title="Search Games">
              <font-awesome-icon icon="search" class="mx-1" aria-hidden="true" />
            </button>
            <button title="Close search box" @click="closeSearch" v-if="isSearchExpanded" class="cancel-search fade-in">
              <font-awesome-icon icon="circle-xmark" class="mx-1" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      <div class="slot-list-wrapper d-flex justify-content-center align-items-start w-100">
        <div class="slot-list row">
          <div v-if="noResults" class="no-results no-games-criteria text-center col-12 fade-in">
            <p class="p">No games found for the selected criteria.</p>
          </div>
          <template v-else-if="!isLoadingCardGames">
            <div  class="game-card col-lg-4 col-md-4 col-sm-6 col-12"
              v-for="(game, index) in displayedGames" :key="game.game_id" :title="game.name"
              @click="launchGames(game.game_id, game.coming_soon)">
              <div class="game-badges">
                <img v-for="cert in game.certifications" :key="cert" :src="getFlagUrl(cert)" class="badge-flag"
                  :title="cert.toUpperCase()" />
              </div>

              <div class="fade-in-fwd wrapper-coming-soon">
                <div v-if="game.coming_soon === 1" class="slot-game-comingsoon-label">
                  <p class="comingsoon-text mb-0">Coming soon</p>
                </div>
              </div>

              <img :id="`game-${index}`" :style="{ animationDelay: `${index * 0.09}s` }"
                class="slot-game-thumb fade-in-fwd" :src="`${getGameThumbnail(game)}?t=${version}`"
                @error="setFallbackImage($event)" :alt="game.name" :class="game.coming_soon === 0 ? 'cursor-pointer' : 'cursor-inherit'
                  " />

              <p class="slot-game-name text-center">{{ game.name }}</p>

              <button v-if="isWindowWideEnough && game.coming_soon === 0" class="play-button"
                :title="`Play ${game.name}!`">
                Play Now
              </button>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/Global/PreLoader.vue";
import pkg from "../../package.json";

export default {
  name: "SlotPage",
  components: { PreLoader },
  data() {
    return {
      searchQuery: "",
      gamesCert: [],
      version: pkg.version,
      isWindowWideEnough: window.innerWidth > 600,
      fallbackImage: "/assets/images/logo.png",
      isSearchExpanded: false,
      selectedFilter: "all",
      selectedCert: "all",
      gameFilters: [
        { type: "all", label: "All" },
        { type: "slot-game", label: "Slot" },
        { type: "crash-game", label: "Crash" },
        { type: "live-casino", label: "Live Casino" },
        { type: "probability", label: "Instant Games" },
        { type: "coming-soon", label: "Coming Soon" },
      ],
    };
  },
  computed: {
    ...mapGetters("casinoGames", ["games", "isLoadingCardGames"]),
    uniqueCertCodes() {
      if (!Array.isArray(this.gamesCert) || this.gamesCert.length === 0)
        return [];
      return [...new Set(this.gamesCert.map((c) => c.code))];
    },

processedGames() {
    if (!this.games?.games || !Array.isArray(this.games.games)) return [];

    const certData = Array.isArray(this.gamesCert) ? this.gamesCert : [];

    return this.games.games
      // Filtra subito i giochi che hanno almeno un'immagine valida
      .filter((game) => game.custom_thumb || game.thumb)
      .map((game) => {
        const certs = certData
          .filter((c) => {
            if (!c) return false;
            if (c.code === "gr") return c.game_id.startsWith(game.game_id);
            return c.game_id === game.game_id;
          })
          .map((c) => c.code);

        return { ...game, certifications: [...new Set(certs)] };
      });
  },

    displayedGames() {
      let filtered = this.processedGames;

      const query = this.searchQuery.toLowerCase();
      if (query.length >= 3) {
        filtered = filtered.filter((g) => g.name.toLowerCase().includes(query));
      }

      if (this.selectedFilter !== "all") {
        filtered = filtered.filter((g) => {
          if (this.selectedFilter === "coming-soon") return g.coming_soon === 1;
          return g.type === this.selectedFilter;
        });
      }

      if (
        this.selectedFilter !== "coming-soon" &&
        this.selectedCert !== "all"
      ) {
        filtered = filtered.filter(
          (g) =>
            g.certifications && g.certifications.includes(this.selectedCert),
        );
      }

      return filtered.slice().sort((a, b) => b.coming_soon - a.coming_soon);
    },

    noResults() {
      return !this.isLoadingCardGames && this.displayedGames.length === 0;
    },
  },
  methods: {
    getFlagUrl(code) {
      const mapping = {
        mga: "mt",
        fbr: "br",
        it: "it",
        gr: "gr",
      };
      const countryCode = mapping[code.toLowerCase()] || code.toLowerCase();
      return `https://flagcdn.com/w40/${countryCode}.png`;
    },
    setFilter(type) {
      this.selectedFilter = type;
      this.scrollToTop();
    },
    toggleSearch(e) {
      e.stopPropagation();
      this.isSearchExpanded = true;
      this.$nextTick(() =>
        document.getElementById("search-games-input")?.focus(),
      );
    },
    closeSearch() {
      this.isSearchExpanded = false;
      this.searchQuery = "";
    },
    launchGames(id, comingSoon) {
      if (comingSoon === 0) this.$router.push(`/gameDetail/${id}/demo`);
    },
    getGameThumbnail(game) {
      const thumb = game?.custom_thumb ?? game?.thumb;
      return `https://storage.googleapis.com/camasy-images/${thumb}`;
    },
    setFallbackImage(e) {
      e.target.src = this.fallbackImage;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      const stickyEl = document.querySelector(".sticky-filters");
      if (!stickyEl) return;
      window.scrollY > 100 || window.innerWidth <= 991
        ? stickyEl.classList.add("sticky-filters-bg")
        : stickyEl.classList.remove("sticky-filters-bg");
    },
    updateWindowWidth() {
      this.isWindowWideEnough = window.innerWidth > 600;
    },
  },
  async created() {
    try {
      await this.$store.dispatch("casinoGames/callEarGames");
      const res = await this.$store.dispatch(
        "casinoGames/callEarCertification",
      );
      this.gamesCert = res || [];
    } catch (error) {
      console.error("Errore API:", error);
      this.gamesCert = [];
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateWindowWidth);
  },
};
</script>

<style scoped>
/* Filtri Certificazioni */
.certification-filters {
  gap: 8px;
  padding: 8px 0;
  overflow-x: auto;
  scrollbar-width: thin !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.cert-filter-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #efefef;
  padding: 4px 10px;
  border-radius: 90px;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
}

.cert-filter-btn.active {
  background: #ffc107;
  color: #000;
  border-color: #ffc107;
  font-weight: 600;
}

.mini-flag {
  width: 16px;
  height: 11px;
  object-fit: cover;
}

/* Bandierine sulle Card */
.game-card {
  position: relative;
  margin-bottom: 20px;
}

.game-badges {
  position: absolute;
  top: 0px;
  right: 25px;
  z-index: 10;
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.badge-flag {
  width: 16px;
  height: auto;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
  border: 0.5px solid rgba(255, 255, 255, 0.4);
}

/* Sticky Header */
.sticky-filters {
  top: 0;
  z-index: 100;
  padding: 10px 0;
}

.sticky-filters-bg {
  background: rgba(15, 15, 15, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.slot-game-thumb {
  width: 100%;
  border-radius: 12px;
  transition: transform 0.3s;
}

.game-card:hover .slot-game-thumb {
  transform: scale(1.03);
}
</style>
<style scoped>
.game-filters {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  position: relative;
  margin-bottom: 0px !important;
  z-index: 2;
  margin: 0 auto 10px;
  overflow-x: auto;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
  width: max-content;
  max-width: 100%;
}

.game-filters::-webkit-scrollbar {
  display: none;
}

.filter-button {
  padding: 0.5rem 1rem;
  background: transparent;
  color: white;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: clamp(14px, 1vw, 17px);
  letter-spacing: -0.09em;
  min-height: 35px;
  transition: 0.3s all ease;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.filter-button:hover {
  /* background: linear-gradient(to right, rgb(96, 115, 236), rgb(19, 54, 193)); */
  background: rgb(19, 54, 193);
  color: white;
  transition: 0.3s all ease;
}

.filter-button.active {
  background: rgb(19, 54, 193);
  color: white;
}

@media (max-width: 768px) {
  .game-filters {
    gap: 0.5rem;
  }

  .filter-button {
    font-size: 12px;
    padding: 0.4rem 0.8rem;
    line-height: 0.9;
  }
}

.min-w-100 {
  min-width: 100%;
}

.disabled-filt {
  opacity: 0.65 !important;
  pointer-events: none !important;
  touch-action: none !important;
}
</style>
